import { useState } from "react";
import Header from "./Components/header/Header";
import Sidebar from "./Components/sidebar/Sidebar";

const Layout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="app-wrapper">
      <Sidebar collapsed={collapsed} />
      <div className={`main-section ${collapsed ? "collapsed" : ""}`}>
        <Header onToggle={() => setCollapsed(!collapsed)} />
        <div className="page-content p-3">{children}</div>
      </div>
    </div>
  );
};

export default Layout;